import React from 'react'
import { Offset, Popup } from '@progress/kendo-react-popup';
import { Menu, MenuItem, MenuSelectEvent } from '@progress/kendo-react-layout';
import { UserApi } from '../../../redux/api/UserApi';
import { ContactOptions } from './ContactOptions';

export const ContactsMenu = (props: MenuProps<ContactOptions>) => {
    const { data: contact } = UserApi.useGetUserByIdQuery(props?.contactId, { skip: !props?.contactId });
    const menuItemSelected = (e: MenuSelectEvent) => {
        //console.log('menuItemSelected', e)

        //Fire the click event for this option
        props.options.find(o => o.id === e.item.data)?.onclick(contact)

        props.itemClicked();
    }

    return (
        <Popup show={props?.visible}
            offset={props?.offset}
            anchorAlign={{ horizontal: 'right', vertical: 'bottom' }} className='contacts-menu' collision={{ horizontal: 'fit', vertical: 'fit' }}  >
            <Menu vertical={true} style={{ display: "inline-block" }} onSelect={menuItemSelected} openOnClick={false} hoverCloseDelay={100}  >
                {props.options.map(o => (
                    <MenuItem render={() => {
                        return <div><img src={o.image} className='tool-image' /> <span>{o.title}</span></div>
                    }} icon={o.icon?.replace('k-i-', '')} text={o.title} data={o.id} />
                ))}
            </Menu>
        </Popup>

    )
}

export type MenuProps<T> = {
    itemClicked: () => void
    contactId: number
    visible: boolean
    offset: Offset,
    options: T[]
}
